module.exports = "/static/assets/3336a4516746eca7bc4a8e981e51a981.svg";